var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessCatering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Catering"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 20.5762V22.627H2.5106L4.56139 26.7285H14.0268L12.6596 30.8301H10.3223V32.8809H24.6777V30.8301H22.3404L20.9732 26.7285H30.4386L32.4894 22.627H35V20.5762H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.2878 6.47678C20.4683 6.08532 20.5762 5.65407 20.5762 5.19531C20.5762 3.49915 19.1962 2.11914 17.5 2.11914C15.8039 2.11914 14.4239 3.49915 14.4239 5.19531C14.4239 5.65407 14.5317 6.08532 14.7123 6.47678C8.55858 7.60818 3.67516 12.4118 2.4292 18.5254H32.5709C31.3249 12.4118 26.4415 7.60818 20.2878 6.47678ZM16.4746 5.19531C16.4746 4.62948 16.9342 4.16992 17.5 4.16992C18.0659 4.16992 18.5254 4.62948 18.5254 5.19531C18.5254 5.76115 18.0659 6.2207 17.5 6.2207C16.9342 6.2207 16.4746 5.76115 16.4746 5.19531Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCatering);
export default __webpack_public_path__ + "static/media/business_catering.dceadada27035d6f3699e73c740ef07e.svg";
export { ForwardRef as ReactComponent };